<template>
  <div>
    <div v-if="loading" class="loading-container">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
      />
    </div>
    <div v-else>
      <b-row>
        <b-col md="12">
          <component-new-header
            title="Customer Management"
            :hasSearch="false"
            :hasReload="false"
            :hasCreate="false"
            :hasback="true"
            @back-press="$router.push(`/customer-management`)"
          />
        </b-col>
      </b-row>
      <b-card>
        <b-row class="customer-info-row">
          <b-col cols="12" sm="12" md="4" class="mb-3 mb-md-0">
            <b-row>
              <b-col cols="12">
                <h3 class="customer-name">
                  {{ details && details.name ? details.name.first : "" }}
                </h3>
                <div class="customer-no-wrapper mt-4">
                  <img :src="`img/User.png`" class="mr-2 icon-height" />
                  <h5 class="customer-no">
                    {{ details ? details.customerNo : "" }}
                  </h5>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" sm="6" md="3" class="mt-2 mb-3 mb-md-0">
            <div class="contact-info">
              <div class="email-wrapper mb-3">
                <img :src="`img/Email.png`" class="mr-2 icon-height" />
                <h5 class="email-text">
                  {{ (contactList[1] && contactList[1].email) || "" }}
                </h5>
              </div>
              <div class="phone-wrapper">
                <img :src="`img/Phone.png`" class="mr-2 mb-1 icon-height" />
                <h5 class="phone-text">
                  {{ (contactList[0] && contactList[0].phone) || "" }}
                </h5>
              </div>
            </div>
          </b-col>
          <b-col cols="12" sm="6" md="3" v-if="details" class="mt-2 mb-3 mb-md-0">
            <template v-for="(address, index) in details.addresses">
              <div
                :key="index"
                v-if="address.isDefault == true"
                class="address-wrapper-default"
              >
                <img :src="`img/Location.png`" class="ml-1 mr-2 icon-height" />
                <h5 class="address-text">
                  {{ address.street1 }},{{ address.street2 }},
                  {{ address.city }},
                  {{ address.state }}
                  {{ address.country }}, {{ address.zip }}
                </h5>
              </div>
              <div
                :key="index"
                v-if="
                  details.addresses.length == 1 && address.isDefault == false
                "
                class="address-wrapper-single"
              >
                <img :src="`img/Location.png`" class="ml-1 mr-2 icon-height" />
                <h5 class="address-text">
                  {{ address.street1 }},{{ address.street2 }},
                  {{ address.city }},
                  {{ address.state }}
                  {{ address.country }}, {{ address.zip }}
                </h5>
              </div>
            </template>
          </b-col>
          <b-col cols="12" sm="12" md="2" class="mt-2 mt-md-0">
            <b-button
              v-if="
                this.$currentUserData.category === 'DISTRIBUTOR' ||
                this.$currentUserData.category === 'DEALER' ||
                this.$currentUserData.category === 'SUB_DEALER'
              "
              variant="primary"
              @click="
                $router.push({
                  name: 'raise-service-request',
                  params: {
                    customerData: details,
                    id: details._id,
                    customerId: currentUser.id,
                  },
                })
              "
              class="service-request-btn w-100"
            >
              <i class="fa fa-plus" aria-hidden="true"></i> New Service
              Request</b-button
            >
          </b-col>
        </b-row>
      </b-card>
      <b-tabs v-model="tabIndex" pills lazy>
        <b-tab>
          <template #title>
            <strong>Order</strong>
            <b-button class="mx-2 customerDetails" variant="dark" pill>{{
              orderCount || 0
            }}</b-button>
          </template>
          <order></order>
        </b-tab>
        <b-tab>
          <template #title>
            <strong>Address Management </strong>
            <b-button class="mx-2 customerDetails" variant="dark" pill>{{
              addressCount || 0
            }}</b-button>
          </template>
          <addressManagement />
        </b-tab>
        <b-tab>
          <template #title>
            <strong>Service Request </strong>
            <b-button class="mx-2 customerDetails" variant="dark" pill>{{
              serviceRequestCount || 0
            }}</b-button>
          </template>
          <serviceRequest />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import VueSimpleSuggest from "vue-simple-suggest";
import ComponentNewHeader from "@/components/componentNewHeader";
import ebSelect from "@/components/FormElements/Select.vue";
import "vue-simple-suggest/dist/styles.css";
import order from "@/views/customerManagement/order.vue";
import addressManagement from "@/views/customerManagement/addressManagement.vue";
import serviceRequest from "@/views/customerManagement/serviceRequest.vue";
import { AtomSpinner } from "epic-spinners";
import awardBenefits from "@/views/customerManagement/awardBenefits.vue";
import raiseServiceRequestVue from "@/views/customerManagement/raiseServiceRequest.vue";
import { mapGetters } from "vuex";
import loader from "@/components/loader/nipigeloader.vue";
export default {
  components: {
    VueSimpleSuggest,
    ComponentNewHeader,
    order,
    addressManagement,
    serviceRequest,
    awardBenefits,
    ebSelect,
    raiseServiceRequestVue,
    loader,
    AtomSpinner,
  },
  data() {
    return {
      tabIndex: 0,
      influencer: false,
      currentUser: "",
      details: "",
      search: "",
      referralDetails: "",
      refererId: "",
      direct: 0,
      group: 0,
      loading: false,
      contactList: [],
    };
  },
  computed: {
    ...mapGetters({
      getOrderCount: "customerManagement/GetOrderGraph",
      getServiceRequestCount: "customerManagement/GetServiceTicketList",
    }),
    orderCount() {
      const dataList = this.getOrderCount;
      if (
        dataList &&
        dataList.response &&
        Array.isArray(dataList.response) &&
        dataList.response.length &&
        dataList.response[0].totalCount
      ) {
        return dataList && dataList.response[0]
          ? dataList.response[0].totalCount
          : 0;
      }
    },
    addressCount() {
      let addressList = this.details?.addresses?.length || "";
      return addressList;
    },
    serviceRequestCount() {
      const dataList = this.getServiceRequestCount;
      if (
        dataList &&
        dataList.data &&
        dataList.data.data &&
        Array.isArray(dataList.data.data) &&
        dataList.data.data.length
      ) {
        return dataList && dataList.data ? dataList.data.data.length : 0;
      }
    },
    getCustomerDetails() {
      return this.$store.getters["customerManagement/GetCustomerDetails"];
    },
  },
  methods: {
    getDeliveryContact() {
      let x = this.details?.addresses ? this.details.addresses : [];
      if (x.length == 0) {
        this.contactList.push({
          phone: this.currentUser?.userData?.authentication?.phone || "",
        });
        this.contactList.push({
          email: this.currentUser?.userData?.authentication?.email || "",
        });
      } else {
        let mainAddress = x[0];
        x.forEach((address) => {
          if (address.isDefault == true) {
            mainAddress = address;
          }
        });
        mainAddress.contacts.forEach((contact) => {
          if (contact.contactType == "PRIMARY_PHONE") {
            this.contactList.push({ phone: contact.value });
          }
          if (contact.contactType == "PRIMARY_EMAIL") {
            this.contactList.push({ email: contact.value });
          }
        });
      }
    },
    async fetchCustomerDetails() {
      const payload = {
        id: this.currentUser.id,
      };
      const data = await this.$store.dispatch(
        "customerManagement/customerDetails",
        payload
      );
      this.details = data;
      this.getDeliveryContact();
      this.refererId = this.details?.metaInfo
        ? this.details.metaInfo.refererId
        : "";
      if (this.refererId) {
        const payload = {
          id: this.refererId,
        };
        const data = await this.$store.dispatch(
          "customerManagement/customerDetails",
          payload
        );
        return (this.referralDetails = data);
      }
      return (this.details = data);
    },
  },
  async mounted() {
    this.currentUser = this.$route.params;
    this.loading= true;
    await this.fetchCustomerDetails();
    this.loading= false;
  },
};
</script>

<style scoped>
.text-grey {
  color: #aaaa;
  background-color: transparent;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}

.btn-dark {
  border-radius: 65%;
  margin-left: 40px;
  height: 28px;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--primary);
  background-color: #fff;
  outline-color: black !important;
}

.tap-top2 {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  color: white;
  text-align: center;
  background: green;
  border: none;
  font-size: 25px;
  padding: 2px;
  cursor: pointer;
  float: right;
  margin-top: 14px;
  margin-right: 88px;
}

.icon-height {
  height: 18px;
}

.referrals-header .card-header {
  background: var(--primary);
  width: 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.referrals-header {
  width: 47%;
}

.customerDetails {
  height: auto;
  width: auto;
}

.nav-link.active {
  border: 1px solid #e7c4c4;
  border-bottom: 0px;
  border-radius: 5px 5px 0px 0px;
}

.customer-info-row {
  align-items: flex-start;
}

.customer-name {
  margin-bottom: 0;
  word-break: break-word;
}

.customer-no-wrapper {
  display: flex;
  align-items: center;
}

.customer-no {
  margin-top: 0;
  margin-left: 28px;
  margin-bottom: 0;
}

.contact-info {
  display: flex;
  flex-direction: column;
}

.email-wrapper {
  display: flex;
  align-items: center;
}

.email-text {
  margin-top: 0;
  margin-left: 0;
  margin-bottom: 0;
  word-break: break-word;
}

.phone-wrapper {
  display: flex;
  align-items: center;
}

.phone-text {
  margin-top: 0;
  margin-bottom: 0;
}

.address-wrapper-default {
  margin-left: 33px;
  display: flex;
  align-items: flex-start;
}

.address-wrapper-single {
  margin-top: 28px;
  display: flex;
  align-items: flex-start;
}

.address-text {
  display: inline;
  position: relative;
  margin-top: 0;
  margin-bottom: 0;
  word-break: break-word;
}

.service-request-btn {
  min-width: 158px;
}

@media (max-width: 767.98px) {
  .customer-no {
    margin-left: 20px;
  }

  .email-text {
    margin-left: 20px;
  }

  .address-wrapper-default {
    margin-left: 20px;
  }

  .service-request-btn {
    min-width: 100%;
  }
}

@media (max-width: 575.98px) {
  .customer-name {
    font-size: 1.25rem;
  }

  .customer-no,
  .email-text,
  .phone-text,
  .address-text {
    font-size: 0.875rem;
  }
}
</style>
